import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import CSelect from '@/components/CForm/CSelect'
import { setReload } from "@/redux/common/action";
import { tableData} from './data'
import './index.scss'

import { getuserlist, fp } from "@/servers/goodsManageApi";
import {withRouter} from "react-router-dom";
import {message, Modal} from "antd";
import MultiSelectPanel from 'react-multi-select-panel';
import 'react-multi-select-panel/index.css'


@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
    this.addHandler = this.addHandler.bind(this);
    this.editHandler = this.editHandler.bind(this);
    this.modalOk = this.modalOk.bind(this);
    this.panelcancel = this.panelcancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onChange = this.onChange.bind(this)
    this.chooseright = this.chooseright.bind(this)
    this.chooseleft = this.chooseleft.bind(this)
    this.toRight = this.toRight.bind(this)
    this.toLeft = this.toLeft.bind(this)
    this.panelSubmit = this.panelSubmit.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // reload时重新加载数据
    // this.getListData();
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    page: tableData.tPage,
    loading: true,
    modal: {
      title: '分配',
      visible: false,
    },
    noSelectedOptions: [],
    selectedOptions: [],
    indicatorlist:[],
    showSelects: false,
    value:'',
    selectopt:[],
    nogroupexpertlist:[],
    leftid:'',
    rightid:''
  };

  onChange(data){
    console.log(data,'tlllll');
    let params = []
    let noselect = []
    this.state.dataSource.forEach(item=>{
      item.expertlist.forEach(item=>{
        item.title = item.name
      })
      if (item.id === data) {
        params = item.expertlist
      }  else {
        noselect.push(item.expertlist)
      }
    })
    this.setState({
      selectedOptions:params,
      value:data,
      noSelectedOptions:noselect.concat(this.state.nogroupexpertlist)
    });
  }

  // 获取用户列表数据
  getListData(){
    let getData = {
      id: ''
    };
    this.setState({
      loading: true
    });
    getuserlist(getData).then(res=>{
      let data =JSON.parse(JSON.stringify(res.records[0].datalist))
      res.records[0].nogroupexpertlist.forEach(item=>{
        item.title = item.name
      })
      const opt = []
      data.forEach(item=>{
        opt.push({
          id:item.id,
          name:item.name
        })
      })
      let total = 1;
      this.setState({
        dataSource: data,
        page: {...this.state.page, total},
        loading: false,
        nogroupexpertlist:res.records[0].nogroupexpertlist,
        selectopt:opt
      });
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  /*新增*/
  addHandler(){
    this.props.history.push({
      pathname: '/expert/addmuseumpersonProvince',
      search: '?type=new'
    })
  }

  // 编辑当前行
  editHandler(data){
    sessionStorage.setItem('userEdit', JSON.stringify(data))
    this.props.history.push({
      pathname: '/expert/addmuseumpersonProvince',
      search: `?type=edit&id=${data.id}`
    })
  }

  fenpei(data){
    const noselect = []
    data.expertlist.forEach(item=>{
      item.title = item.name
    })
    this.state.dataSource.forEach(item=>{
      if (item.id !== data.id) {
        item.expertlist.forEach(item1=>{
          item1.title = item1.name
          noselect.push(item1)
        })
      }
    })
    this.setState({
      selectedOptions:data.expertlist,
      value:data.id,
      noSelectedOptions:noselect.concat(this.state.nogroupexpertlist)
    },()=>{
      this.setState({
        modal: {...this.state.modal, visible: true},
      })
    });
  }

  modalOk(){

  }

  panelSubmit() {
    const ids = []
    this.state.selectedOptions.forEach(item=>{
      ids.push(item.id)
    })
    const params = {
      expertids: ids.join(',')
    }
    params.groupid = this.state.value
    fp(params).then(res=>{
      if (res.statecode === 0) {
        message.success('专家分配成功');
        this.getListData()
        this.panelcancel()
      }
      else {
        message.error('专家分配失败');
      }
    })
  }

  panelcancel() {
    this.setState({
      noSelectedOptions:[],
      selectedOptions:[],
      leftid:'',
      rightid:'',
    },()=>{
      this.setState({
        modal: {...this.state.modal, visible: false},
      })
    })
  }

  chooseleft(id){
    if (this.state.leftid === '') {
      this.setState({
        leftid:id
      })
    } else {
      this.setState({
        leftid:''
      })
    }
  }

  chooseright(id){
    if (this.state.rightid === '') {
      this.setState({
        rightid:id
      })
    } else {
      this.setState({
        rightid:''
      })
    }
  }

  toRight(){
    if (this.state.leftid === '') {
      return false
    }
    const d = this.state.noSelectedOptions
    const l = this.state.selectedOptions
    l.forEach((item,index)=>{
      if (item.id === this.state.leftid) {
        l.splice(index,1)
        d.push(item)
      }
    })
    this.setState({
      noSelectedOptions:d,
      selectedOptions:l,
      leftid:'',
      rightid:''
    })
  }

  toLeft(){
    if (this.state.rightid === '') {
      return false
    }
    const d = this.state.noSelectedOptions
    const l = this.state.selectedOptions
    d.forEach((item,index)=>{
      if (item.id === this.state.rightid) {
        d.splice(index,1)
        l.push(item)
      }
    })
    this.setState({
      noSelectedOptions:d,
      selectedOptions:l,
      leftid:'',
      rightid:''
    })
  }

  handleChange(){

  }

  componentWillMount(){

  }

  componentDidMount(){
    this.getListData();
  }
  render(){
    return (
        <div className='user-manage-list'>
          <div className='flex filter-wrap'>
            <div className='flex filter-left'>
              <CButton type='primary' authId='goodsManageListNewAdd' onClick={this.addHandler}>新增</CButton>
            </div>
          </div>
          <CTable ref='userManageList' checked={false} loading={this.state.loading} columns={this.state.columns} dataSource={this.state.dataSource} onTableChange={this.onTableChange}>
            <div
                slot='index'
                render={(text, record, index) => (
                    <div className='operate'>
                      {index+1}
                    </div>
                )} />
            <div
                slot='operate1'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.fenpei(record)}>分配</CButton>
                    </div>
                )} />
            <div
                slot='operate'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.editHandler(record)}>编辑</CButton>
                    </div>
                )} />
          </CTable>
          <Modal
              title={this.state.modal.title}
              visible={this.state.modal.visible}
              onCancel={this.panelcancel}
              footer={null}
              width={560}
          >
            <div>
              <CSelect
                  value={this.state.value}
                  options={this.state.selectopt}
                  placeholder='请选择专家来源'
                  onChange={this.onChange}
                  />
              <div className={'selectbox'}>
                <div className="leftbox">
                  <div className={'titlebox'}>组内专家</div>
                  <div className={'leftbox-content'}>
                    {
                      this.state.selectedOptions.map(item=>{
                        return (
                            <div onClick={()=>{this.chooseleft(item.id)}} style={this.state.leftid === item.id ? {background:'#bebebe'}:{}}>{item.title}</div>
                        )
                      })
                    }
                  </div>
                </div>
                <div className="btn">
                  <CButton onClick={this.toRight}>》》</CButton>
                  <CButton onClick={this.toLeft} style={{marginTop:'20px'}}>《《</CButton>
                </div>
                <div className="rigghtbox">
                  <div className={'titlebox'}>非组内专家</div>
                  <div className={'rigghtbox-content'}>
                    {
                      this.state.noSelectedOptions.map(item=>{
                        return (
                            <div onClick={()=>{this.chooseright(item.id)}} style={this.state.rightid === item.id ? {background:'#bebebe'}:{}}>{item.title}</div>
                        )
                      })
                    }
                  </div>
                </div>
              </div>
              <div style={{marginTop:'30px',display:'flex',justifyContent:'center'}}>
                <CButton onClick={this.panelcancel}>取消</CButton>
                <CButton type="primary" onClick={this.panelSubmit} style={{marginLeft:'40px'}}>确定</CButton>
              </div>
            </div>
          </Modal>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
